export default __webpack_public_path__ + "media/Entrepreneurship.9df27f50.png";